/**
 * Class added to markdown chart containers while they are rendering in headless mode.
 * Removed once the Highcharts 'load' event fires, indicating the chart is fully rendered.
 * Used by waitForAppQuiescence() to determine when all charts are ready for PDF capture.
 */
export const HEADLESS_CHART_RENDERING_CLASS = 'markdownChartRendering';

/**
 * Class added to placeholders for lazy-loaded markdown UI components in headless mode.
 * Used by capture pages to ensure the component code has loaded before taking a PDF.
 */
export const HEADLESS_UI_COMPONENT_RENDERING_CLASS = 'markdownUiComponentRendering';

/**
 * Custom URI scheme for internal Seeq links (workspace, future internal navigation, etc.)
 */
export const SEEQ_SCHEME = 'seeq://';

/**
 * Full prefix for workspace links: seeq://workspace/
 */
export const WORKSPACE_LINK_PREFIX = 'seeq://workspace/';
